import React from 'react';
import { NavLink } from 'react-router-dom';
import { getFooterNavClass } from './Nav';
import siteData from '../data/site.json';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div>
          <div className="footer-top-profile">
            <img
              src="/images/headshots/JP2.1_BW.webp"
              loading="lazy"
              width="60"
              alt="Jo"
              className="border-radius-circle"
            />
            <div>
              <h1 className="heading-style-h5">{siteData.name}</h1>
              <div className="text-meta text-color-muted-inverse">{siteData.role}</div>
            </div>
          </div>
        </div>
        {/* <a
          data-wf--button--variant="base"
          href="https://templates.gola.io/"
          target="_blank"
          rel="noreferrer"
          className="button w-inline-block"
        >
          <div className="button-inner">
            <div className="button-inner-text">More Templates</div>
            <div className="button-inner-text-hover">More Templates</div>
          </div>
        </a> */}
      </div>
      <div className="footer-grid">
        <div className="footer-column">
          <h3 className="heading-style-h6">Pages</h3>
          <div className="footer-nav">
            <NavLink to="/" className={getFooterNavClass}>
              <div className="nav-item-text">Home</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
            <NavLink to="/about" className={getFooterNavClass}>
              <div className="nav-item-text">About</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
            <NavLink to="/contact" className={getFooterNavClass}>
              <div className="nav-item-text">Contact</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="heading-style-h6">CMS</h3>
          <div className="footer-nav">
            <NavLink to="/work" className={getFooterNavClass}>
              <div className="nav-item-text">Work</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
            <NavLink to="/labs" className={getFooterNavClass}>
              <div className="nav-item-text">Labs</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
            {/* <a
              href="https://hanssen-template.webflow.io/projects/darkness"
              target="_blank"
              rel="noreferrer"
              className="nav-item inverse w-inline-block"
            >
              <div className="nav-item-text">Work Single</div>
              <div className="nav-item-line inverse"></div>
            </a> */}
{/*             <NavLink to="/blog" className={getFooterNavClass}>
              <div className="nav-item-text">Blog</div>
              <div className="nav-item-line inverse"></div>
            </NavLink> */}
            {/* <a
              href="https://hanssen-template.webflow.io/post/capturing-the-essence-how-to-tell-stories-through-photography"
              target="_blank"
              rel="noreferrer"
              className="nav-item inverse w-inline-block"
            >
              <div className="nav-item-text">Blog Single</div>
              <div className="nav-item-line inverse"></div>
            </a> */}
          </div>
        </div>
        
        <div className="footer-column">
          <h3 className="heading-style-h6">Licensing</h3>
          <div className="footer-nav">
            <NavLink to="/licensing" className={getFooterNavClass}>
              <div className="nav-item-text">Credits</div>
              <div className="nav-item-line inverse"></div>
            </NavLink>
          </div>
        </div>

      </div>
      <div className="footer-bottom">
        {/* <div className="text-color-muted-inverse">
          © Made by{' '}
          <a href="https://templates.gola.io/" target="_blank" rel="noreferrer" className="text-style-link-inverse">
            Pawel Gola
          </a>{' '}
          - Powered by{' '}
          <a href="https://www.webflow.com" target="_blank" rel="noreferrer" className="text-style-link-inverse">
            Webflow
          </a>
        </div> */}
      </div>
      {/* <a href="http://gola.io/hanssen" target="_blank" rel="noreferrer" className="buy-badge w-inline-block">
        <img src="/images/buy-badge-webflow-icon.svg" loading="lazy" width="20" alt="Webflow Icon" />
        <img src="/images/buy-badge-text.svg" loading="lazy" alt="" />
      </a> */}
    </footer>
  );
};

export default Footer;

